import React from 'react';

type PlanIncludedNodesState = {
  includedNodeTypes?: Set<string> | null;
};

const listeners = new Set<() => void>();

let state: PlanIncludedNodesState = {
  includedNodeTypes: undefined,
};

function emit() {
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot() {
  return state;
}

export function setPlanIncludedNodeTypes(
  includedNodeTypes: Set<string> | null | undefined
) {
  state = { includedNodeTypes };
  emit();
}

export function resetPlanIncludedNodeTypes() {
  state = { includedNodeTypes: undefined };
  emit();
}

export function usePlanIncludedNodeTypesState() {
  return React.useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}

export function getPlanIncludedNodeTypesState() {
  return state;
}

